var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vector2i, VRect, CloneWithPrototypes } from "js-vextensions";
import { Column } from "react-vcomponents";
import { GetMapObjects, GetSelectedMapObject } from "Store/firebase/mapObjects";
import { ShapeType } from "Store/firebase/mapObjects/Components/@ShapeComp";
import { Observer } from "vwebapp-framework";
import { runInAction } from "mobx";
import { store } from "Store";
import { ToolUI } from "./Tool";
import { MapObjectUI } from "../MapObjectUI";
let SelectObject = class SelectObject extends ToolUI({}, {}) {
    render() {
        return (React.createElement(Column, null));
    }
    Scene_OnMouseDown(e) {
        if (e.button != 0)
            return;
        const objects = GetMapObjects();
        const mousePos_canvas = this.MapScene.MousePos_Canvas(new Vector2i(e.pageX, e.pageY));
        const mousePos_world = this.MapScene.MousePos_World(mousePos_canvas);
        const mousePos_world_rect = new VRect(mousePos_world, Vector2i.zero);
        const objectDistances = objects.map(obj => {
            if (obj.shape == null)
                return Number.MAX_SAFE_INTEGER;
            const objPos = obj.position.As(Vector2i);
            if (obj.shape.type == ShapeType.Rectangle) {
                const rect_world = obj.shape.rect.As(VRect).NewX(x => objPos.x + x).NewY(y => objPos.y + y);
                // if clicked on rect, consider distance-to-mouse to be 50 pixels (thus, rect is considered clicked instead of lines so long as mouse is farther than 50 pixels from any line)
                return rect_world.Intersects(mousePos_world_rect) ? (50 * this.MapScene.PixelLengthInMeters()) : Number.MAX_SAFE_INTEGER;
            }
            if (obj.shape.type == ShapeType.Path || obj.shape.type == ShapeType.Region) {
                const pointDistances = obj.shape.pathPoints.map(point => mousePos_world.DistanceTo(objPos.Plus(point)));
                const closestPoint = obj.shape.pathPoints.OrderBy((point, index) => pointDistances[index]).First();
                return pointDistances[obj.shape.pathPoints.indexOf(closestPoint)];
            }
            return Number.MAX_SAFE_INTEGER;
        });
        const closestObject = objects.OrderBy((obj, index) => objectDistances[index]).First();
        runInAction("SelectObject.Scene_OnMouseDown", () => store.main.write.selectedObject = closestObject._key);
        return true;
    }
    RenderInScene() {
        const selectedObject = GetSelectedMapObject();
        if (selectedObject == null)
            return null;
        const objHighlight = CloneWithPrototypes(selectedObject);
        if (objHighlight.shape) {
            //objHighlight.shape.thickness *= 2;
            objHighlight.shape.color = "rgba(255,255,255,.5)";
        }
        return React.createElement(MapObjectUI, { obj: objHighlight, mapScene: this.MapScene, worldViewArea: this.MapScene.WorldViewArea() });
    }
};
SelectObject = __decorate([
    Observer
], SelectObject);
export { SelectObject };
/*function WithIncreasedThickness<T extends MapObject | ShapeComp>(objOrShape: T, thicknessModifierFunc: (a: number)=>number) {
    let newShape = CloneWithPrototypes(objOrShape["shape"] || objOrShape) as ShapeComp;
    newShape.thickness = thicknessModifierFunc(newShape.thickness);
    return (objOrShape["shape"] ? objOrShape.Extended({shape: newShape}) : newShape) as T;
}*/ 
